/* eslint-env browser */
(function() {
  'use strict';

  window.nasos = window.nasos || {};
})();
